const useIsHalGUI = (): boolean => {
  const isHalGui = window.location.pathname.includes('hal/mfe_mysites');
  return isHalGui;
};

export default useIsHalGUI;
